import { Helmet } from 'react-helmet';
import { Box, Container } from '@mui/material';

import SettingsPassword from 'src/components/settings/SettingsPassword';

const SettingsView = ({ user, startLoading, stopLoading }) => (
  <>
    <Helmet>
      <title>Change Password | GMS</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ pt: 3 }}>
          <SettingsPassword
            user={user}
            startLoading={startLoading}
            stopLoading={stopLoading}
          />
        </Box>
      </Container>
    </Box>
  </>
);

export default SettingsView;
